var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
import { DatatypesMapperModel } from "./model";
export function getDatatypesMapper(upload_only = true) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().GET("/api/datatypes/types_and_mapping", {
            params: { query: { upload_only } },
        });
        if (error) {
            rethrowSimple(error);
        }
        return new DatatypesMapperModel(data);
    });
}
